const COLORS_EVEN = [
  '#9600b6',
  '#93b5de',
  '#4976b2',
  '#2f3a52',
  '#feb842',
  '#f37e56',
  '#ebb9a8',
];

const COLORS_ODD = [
  '#ebb9a8',
  '#9600b6',
  '#93b5de',
  '#4976b2',
  '#2f3a52',
  '#feb842',
  '#f37e56',
];

const colors = {
  odd: COLORS_ODD,
  even: COLORS_EVEN,
};

export default colors;
